// @flow
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { Cookies } from 'react-cookie';
import apiMiddleware from './apiMiddleware';
import sessionMiddleware from './sessionMiddleware';
import authReducer from './auth';
import partnerReducer from './partners';
import permissionReducer from './permissions';
import newsletterUriReducer from './newsletterUri';

import type {
  State as PermissionState,
  Actions as PermissionActions
} from './permissions';
import type {
  State as PartnerState,
  Actions as PartnerActions
} from './partners';
import type {
  State as NewsletterUriState,
  Actions as NewsletterUriActions
} from './newsletterUri';
import type { State as AuthState, Actions as AuthActions } from './auth';
import { Brands } from '../common/constants';

export type State = {
  permissionReducer: PermissionState,
  newsletterUriReducer: NewsletterUriState,
  authReducer: AuthState,
  partnerReducer: PartnerState,
  appReducer: { brand: string }
};

export type Actions = PermissionActions | NewsletterUriActions | PartnerActions | AuthActions;

export default ({ brand, api }) => {
  const middleware = [apiMiddleware(api), sessionMiddleware()];
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
      : compose;

      const enhancer = composeEnhancers(applyMiddleware(...middleware));

  const rootReducer = combineReducers({
    appReducer: (state = {}) => state,
    authReducer,
    partnerReducer,
    permissionReducer,
    newsletterUriReducer
  });

  const hydrateSession = () => {
    const cookies = new Cookies();
    const sessionToken = cookies.get('nuk_pc') || null;
    return sessionToken ? { token: sessionToken } : {};
  };

  const hasAcsSession = () => {
    const cookies = new Cookies();
    if(brand === Brands.TheSun){
      const sessionToken = cookies.get('acs_ngn', {domain: '.thesun.co.uk'}) || null;
      return !!sessionToken;
    }
    else if(brand === Brands.TheTimes){
      const sessionToken = cookies.get('acs_tnl', {domain: '.thetimes.co.uk'}) || null;
      return !!sessionToken;
    }
    else if(brand === Brands.TheTimesCom){
      const sessionToken = cookies.get('acs_tnl', {domain: '.thetimes.com'}) || null;
      return !!sessionToken;
    }
    else if(brand === Brands.Wireless){
      const sessionToken = cookies.get('acs_wls', {domain: '.wireless.radio'}) || null;
      return !!sessionToken;
    }
    else if(brand === Brands.Tls){
      const sessionToken = cookies.get('acs_tls', {domain: '.the-tls.co.uk'}) || null;
      return !!sessionToken;
    }
    else if(brand === Brands.TlsCom){
      const sessionToken = cookies.get('acs_tls', {domain: '.the-tls.com'}) || null;
      return !!sessionToken;
    }
    return false;
  }

  const hydratedState = {
    appReducer: { brand },
    authReducer: { 
      session: hydrateSession(),
      acsSession: hasAcsSession()
    }
  };
  return createStore(rootReducer, hydratedState, enhancer);
};
